import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { GlobalPanicAlertService } from './global-panic-alert.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private router: Router, 
    private api: ApiService,
    private globalPanicAlertService: GlobalPanicAlertService
  ) {
  }
  private isValid: Subject<boolean> = new Subject<boolean>();

  /**
   * method observable
   */
  public isLogged: Observable<boolean> = this.isValid.asObservable();



  public logout() {
    this.globalPanicAlertService.cleanup();
    sessionStorage.removeItem('token');
    this.router.navigate(['/login']);
  }


}
